import {useQuery} from "@tanstack/react-query";
import {readShipmentDetail} from "../../../../../api/order/OrdersApi";
import {ordersDetailInit} from "../state";

type Props = {
    param: string;
};

export const useReadShipmentDetail = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readShipmentDetail", param],
        queryFn: async () => await readShipmentDetail(param),
        select: (res) => res?.data.result ?? ordersDetailInit,
    });

    return {data};
};
